// /field/* capture-zone gate — FIELD_REP does the capturing, ADMIN for
// support/testing. Same pair the warehouse pages inline as their write-roles
// set (e.g. WarehouseItemsPage WAREHOUSE_VIEW_ROLES); lifted to shared/auth
// so the App.jsx route guard and future field UI read one source. Mirrors
// the disposalRoles.js pattern.
export const FIELD_ROLES = ['ADMIN', 'FIELD_REP'];

export function hasFieldAccess(role) {
  return FIELD_ROLES.includes(role);
}
